<template>
  <div class="footer">
    <div class="footerCon">
      <div class="footerTop clearfix">
        <ul class="pull-left hidden-xs clearfix">
          <li class="pull-left" v-for="(footer,index) in footerColumnInfos" :key="index">
            <h4  >{{footer.columnName}}</h4>
            <p v-for="(footerChild,childIndex) in footer.children" :key="childIndex"><a href="#" @click="jump(footerChild.columnAccessPath)">{{footerChild.columnName}}</a></p>
          </li>
        </ul>
        <div class="pull-right customerService">
          <h4>客服中心</h4>
          <p>工作时间：<span>工作日 08:30-17:00</span></p>
          <p>客服热线：<span class="telephone">{{webConfigInfo.mobolePhone}}</span></p>
          <p>客服邮箱：<span>{{webConfigInfo.email}}</span><span class="hidden-xs hidden-sm complaint" @click="toComplain()">我要投诉</span></p>
          <img :src="webConfigInfo.publicNumberTwoDimensionalCodeAttachementUrl" alt="">
        </div>
      </div>
      <div class="footerBottom">
        <p>
        <span style="cursor: pointer"><a href="http://218.242.124.22:8081/businessCheck/verifKey.do?showType=extShow&serial=9031000020180928141425000002866592-SAIC_SHOW_310000-2018122018594033566&signData=MEYCIQCnB/Y+kI/GVR1Y8azeek7w7m7dnx1ziJ82bb+bl/0jBwIhAJMECiAYasxbH+nRD7qS1010iwZUN6zgz3xWGmv8fHqC" target="_blank"><img :src="webConfigInfo.businessCertificationAttachmentUrl" alt="">版权 {{webConfigInfo.websiteAuthorization}} 本公司保留一切版权</a></span>
        <!-- <span>备案证书号：{{webConfigInfo.publicNetworkSecurityNumber}}</span> -->
        </p>
        <p>
        <span  style="cursor: pointer"><img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/ghs.png" alt=""><a stle="text-decoration:none" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011002003624" target="view_window">公安备案号：31011002003624</a></span>
        <span ><a stle="text-decoration:none" href="https://beian.miit.gov.cn" target="view_window">备案证书号：沪ICP备05004652号-8</a></span>
        <span ><a stle="text-decoration:none" href="https://beian.miit.gov.cn" target="view_window">增值电信业务经营许可证：沪B2-20190630</a></span>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['webConfigInfo','footerColumnInfos'],
  data () {
    return {
    }
  },
  created () {
  },
  methods:{
    toComplain(){
      this.$router.push({path:'/complain'})
    },
    jump(url){
      if(/Android|webOS|iPhone|iPad|BlackBerry/i.test(navigator.userAgent)) {
        return;
      } else {
        if(url.indexOf('http') == 0){
          window.location.href = url;
        }else{
          this.$router.push({path:url});
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/v-footer/index.vue